import React, { useCallback, useState } from "react";

export interface IBrandOrService {
  linkUrl: string;
  menuIconImage: string;
  description: string;
  image: string;
  name: string;
  mobileMenuIconImage: string;
  sequence: number;
}

export interface BrandOrServiceProps {
  brandOrService: IBrandOrService;
  mobile?: boolean;
}

function BrandOrService(props: BrandOrServiceProps) {
  const maxForegroundImagePadding = 20;
  const minForegroundImagePadding = 4;
  const [foregroundImagePadding, setForegroundImagePadding] = useState(
    maxForegroundImagePadding
  );
  const [foregroundImageLoaded, setForegroundImageLoaded] = useState(0);
  const foregroundImageRef = useCallback(
    (node: HTMLImageElement) => {
      const desiredHeight = 75;
      if (node !== null && node.height) {
        setForegroundImagePadding(
          Math.max(
            (desiredHeight - node.height) * 0.5,
            minForegroundImagePadding
          )
        );
      }
    },
    // need props.brandOrService, props.mobile, foregroundImageLoaded in dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.brandOrService, props.mobile, foregroundImageLoaded]
  );

  return (
    <a href={props.brandOrService.linkUrl}>
      <span className="bas-wrapper">
        {!props.mobile &&
          (props.brandOrService.menuIconImage ? (
            <img
              className="bas-background"
              src={props.brandOrService.menuIconImage}
              alt={props.brandOrService.name}
            />
          ) : (
            <div className="bas-background" />
          ))}
        <span>
          <img
            className="bas-foreground"
            src={props.brandOrService.image}
            ref={foregroundImageRef}
            style={{ padding: foregroundImagePadding }}
            onLoad={() => {
              // foregroundImageLoaded is an int so foregroundImageRef's useCallback will trigger on subsequent onLoads (ie: when src is changed)
              setForegroundImageLoaded(foregroundImageLoaded + 1);
            }}
            alt={props.brandOrService.name + " Text"}
          />
          <b className={props.mobile ? "font-weight-bold" : ""}>
            {props.brandOrService.description}
          </b>
          {props.mobile && <span className="bas-shop-now">Shop Now</span>}
        </span>
      </span>
    </a>
  );
}

export default BrandOrService;
